<template>
  <div class="hp-card">
    <div class="hp-main-container">
      <div class="hp-top-bar"></div>
      <div class="hp-message">
        {{ `${"How would you rate your experience with us ?"}` }}
      </div>
      <div class="hp-feedback">
        <div>
          <img
            class="align-self-center mx-2 status-icon"
            src="@/assets/images/feedback1.svg"
            alt=""
          />
        </div>
        <div>
          <img
            class="align-self-center mx-2 status-icon"
            src="@/assets/images/feedback3.svg"
            alt=""
          />
        </div>
        <div>
          <img
            class="align-self-center mx-2 status-icon"
            src="@/assets/images/feedback2.svg"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="hp-contact-container">
      <div class="hp-contact-message">
        {{
          `${"For support requests, please email our dedicated support team on"}`
        }}
      </div>
      <div class="hp-contact-email">
        {{ `${"support@patientlink.digital"}` }}
      </div>
    </div>
  </div>
</template>

<script>
import { videoMixin } from "@/mixins/videoMixin";
export default {
  mixins: [videoMixin],
};
</script>
<style>
.hp-main-container {
  background: #fff;
}
.hp-top-bar {
  height: 4px;
  background: #07752b;
}
.hp-message {
  padding: 15px;
  text-align: center;
}
.hp-feedback {
  display: flex;
  padding: 0px 40px 17px 40px;
  align-items: center;
  justify-content: space-evenly;
}
.hp-contact-container {
  margin: 40px 20px;
  text-align: center;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #333;
}
.hp-contact-email {
  padding-top: 20px;
  color: #005eb8;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: center;
  color: #005eb8;
}
</style>
